export default __webpack_public_path__ + "../staticImages/benefit-international.svg";